import './antPopover.less';

import React from 'react';
import { observer } from 'mobx-react';
import { Popover, PopoverProps } from 'antd';
import b_ from 'b_';
import classnames from 'classnames';

import { useDefaultZIndex } from 'framework/react-integration';
import { CssVariables } from 'styles/cssVariables';

const b = b_.with('ant-popover-wrapper');

export interface AntPopoverProps extends Omit<
	PopoverProps,
	'overlayClassName' | 'overlayStyle' | 'overlayInnerStyle' | 'destroyTooltipOnHide'
> {
	onModal?: boolean;
	overlayPadding?: boolean;
}

export const AntPopover = observer((props: AntPopoverProps) => {
	const { overlayPadding, classNames, styles, ...rest } = props;

	// classNames/styles can also be a function (per-render semantic customization) - not used
	// anywhere in our codebase so ignored for now
	const classNamesObj = typeof classNames === 'function' ? undefined : classNames;
	const stylesObj = typeof styles === 'function' ? undefined : styles;

	const withoutPadding = !overlayPadding;
	const fullOverlayClassName = classnames(b('overlay', { 'without-padding': withoutPadding }), classNamesObj?.root);

	const rootStyleWrapped = useDefaultZIndex(stylesObj?.root, CssVariables.zIndexControlPopover);

	return (
		<Popover
			className={b()}
			{...rest}
			classNames={{ ...classNamesObj, root: fullOverlayClassName }}
			styles={{ ...stylesObj, root: rootStyleWrapped }}
		/>
	);
});

type UsePopoverManuallyArgs = {
	timeout: number;
};

export function usePopoverManually(args: UsePopoverManuallyArgs) {
	const [opened, setOpened] = React.useState(false);
	const [label, setLabel] = React.useState('');

	const timeoutHolder = React.useRef<number>(null);

	const open = React.useCallback(
		(label: string) => {
			setOpened(true);
			setLabel(label);

			if (timeoutHolder.current) {
				clearTimeout(timeoutHolder.current);
			}

			timeoutHolder.current = window.setTimeout(() => {
				setOpened(false);
			}, args.timeout);
		},
		[args.timeout],
	);

	return {
		opened,
		open,
		label,
	};
}
